import Axios from "axios";
import { pocService, pocClient as poc } from "../pocConfig";

export const getListOfLists = (page, itemsPerPage, filters) => {
   const filterQuery =
      filters?.column && filters?.userInput ? `&${filters.column}=${filters.userInput}` : "";
   //TODO: this request should look like this:
   // page=${page}&size=${itemsPerPage}/lists/queries?${filterQuery}
   //hoever, i was ask to reverse the list, becouse backend returns object from the oldest to newest
   //feching last page returns sometime less then 10 elements
   return poc.get(`/lists/queries`);
   // ${filterQuery}
};

export const createNewList = (body) => {
   return poc.post("/lists/commands", body);
};

export const editV3List = (body, listId) => {
   return poc.put(`/lists/commands/${listId}`, body);
};

export const copyV3ListWithParentForm = (listId, copyWithParentForm) => {
   return poc.post(`/lists/commands/${listId}/copy?copyPresenterForm=${copyWithParentForm}`);
};

export const deleteV3List = (listId) => {
   return poc.delete(`/lists/commands/${listId}`);
};

export const getAllActions = () => {
   return poc.get(`/lists/meta/actions`);
};

export const getListStruct = (listId) => {
   return poc.get(`/lists/queries/struct/${listId}`);
};
